import angular from "angular";
import constantsModule from "../../constants/constants.module";

export default angular.module("sbApp.common.featureFlags", [
    constantsModule.name,
]);
